import React from 'react';
import {connect} from 'react-redux';
import SeguridadForm from '../registro-seguridad/seguridad.frm';

const mapDispatch = (dispatch) => {
    return {
        loader: (show) => {
            dispatch({"type": "LOADER", "show": show});
        },        
		siguientePaso: () => {
			dispatch({ "type": "REGISTRO_FAMILIAR_PASO", paso: 2});
		},
        registrarDatos(oDatosForm) {
            dispatch({
                "type": "REGISTRO_FAMILIAR_SEGURIDAD",
                "password": oDatosForm.password,
                "pregunta1": oDatosForm.pregunta1,
                "respuesta1": oDatosForm.respuesta1,
                "pregunta2": oDatosForm.pregunta2,
                "respuesta2": oDatosForm.respuesta2
            })
        }
    }
}

class Seguridad extends React.Component{

	submit = (data) => {
	    this.props.loader(true);
        return new Promise((resolve) => {
            this.props.registrarDatos(data);
            this.props.siguientePaso();
            this.props.loader(false);
            resolve();
        });	    
	}

	render() {
		return <SeguridadForm onSubmit={this.submit} />
	}
}

export default connect(null, mapDispatch)(Seguridad);


// WEBPACK FOOTER //
// ./src/registro-familiar/seguridad.cmpt.js